import { render, staticRenderFns } from "./GuidelineArea.vue?vue&type=template&id=5f438546&scoped=true&"
import script from "./GuidelineArea.vue?vue&type=script&lang=ts&"
export * from "./GuidelineArea.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineArea.vue?vue&type=style&index=0&id=5f438546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f438546",
  null
  
)

export default component.exports